/**
 * SidebarItem Component
 *
 * Individual navigation item for the sidebar.
 * Supports active state highlighting.
 */

import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  type SxProps,
  type Theme,
} from '@mui/material';

interface SidebarItemProps {
  label: string;
  path: string;
  icon: React.ReactElement;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  label,
  path,
  icon,
  onClick,
  sx,
}) => {
  const location = useLocation();
  const isActive = location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        component={RouterLink}
        to={path}
        onClick={onClick}
        selected={isActive}
        sx={{
          minHeight: 48,
          px: 2.5,
          ...sx,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 3,
            justifyContent: 'center',
            color: 'inherit',
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: '0.875rem',
            fontWeight: isActive ? 600 : 400,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
